<div class="tp-page notifications-center">
  <tp-page-header title="Centro de notificaciones" subtitle="Tus notificaciones de los últimos 30 días">
    <div actions class="notifications-center__actions">
      <mat-slide-toggle [checked]="filterOnlyToRead" (change)="showOnlyUnread($event)">
        Mostrar solo las no leídas
      </mat-slide-toggle>
      <button mat-stroked-button type="button" [disabled]="!hasNotificationsToRead()" (click)="markAllAsRead()">
        <mat-icon>done_all</mat-icon>
        Marcar todas como leídas
      </button>
    </div>
  </tp-page-header>

  <section class="tp-card tp-card--flush" aria-label="Notificaciones">
    @if (notifications.length === 0) {
      @if (filterOnlyToRead) {
        <tp-empty-state
          icon="mark_email_read"
          title="Ya leíste todas tus notificaciones"
          message="No hay notificaciones sin leer de los últimos 30 días."
        ></tp-empty-state>
      } @else {
        <tp-empty-state
          icon="notifications_none"
          title="No tenés notificaciones"
          message="Cuando haya novedades de los últimos 30 días van a aparecer acá."
        ></tp-empty-state>
      }
    } @else {
      <ul class="notification-list">
        @for (notification of notifications; track notification.id) {
          <li class="notification" [class.notification--unread]="notification.status == 2">
            <button
              type="button"
              class="notification__status"
              [attr.aria-label]="notification.status == 2 ? 'Marcar como leída' : 'Marcar como no leída'"
              [title]="notification.status == 2 ? 'Marcar como leída' : 'Marcar como no leída'"
              (click)="markNotification(notification.id)"
            >
              <span class="notification__dot" aria-hidden="true"></span>
            </button>
            <span class="notification__icon" aria-hidden="true">
              <mat-icon>notifications</mat-icon>
            </span>
            <div class="notification__body">
              <div class="notification__head">
                <p class="notification__title">{{ notification.title }}</p>
                <time class="notification__date">{{ notification.sentDate | date : "dd/MM/yyyy HH:mm" }}</time>
              </div>
              @if (notification.description) {
                <p class="notification__description">{{ notification.description }}</p>
              }
              @if (notification.type == 10) {
                <button type="button" class="notification__link"
                  (click)="goSupplierDetail(notification.extraInfo.contractorId); markNotification(notification.id)">
                  Ver perfil del nuevo prestador
                </button>
              }
              @if (notification.type == 13 || notification.type == 14 || notification.type == 15) {
                <button type="button" class="notification__link"
                  (click)="goToOADetails(notification.extraInfo.assemblyOrderId); markNotification(notification.id)">
                  Ver Orden de Montaje modificada
                </button>
              }
              @if (notification.type == 16) {
                <button type="button" class="notification__link"
                  (click)="goToSapArticleDetails(notification.extraInfo.manufacturingItemId); markNotification(notification.id)">
                  Ver nuevo artículo SAP
                </button>
              }
              @if (notification.type == 17) {
                <button type="button" class="notification__link"
                  (click)="goToTaskDetails(notification.extraInfo.taskId); markNotification(notification.id)">
                  Ver detalle de tarea
                </button>
              }
              @if (notification.type == 23) {
                <button type="button" class="notification__link"
                  (click)="goToBudget(notification.extraInfo.budgetId); markNotification(notification.id)">
                  Ver presupuesto
                </button>
              }
            </div>
          </li>
        }
      </ul>
    }
  </section>
</div>
